import {
  AppRootElementBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { SignalsDisplay } from '@backstage/plugin-signals';

const visitListenerElement = AppRootElementBlueprint.make({
  name: 'visit-listener',
  params: {
    element: <></>,
  },
  disabled: true,
});

const signalsDisplayElement = AppRootElementBlueprint.make({
  name: 'signals-display',
  params: {
    element: <SignalsDisplay />,
  },
});

export const appRootModule = createFrontendModule({
  pluginId: 'app',
  extensions: [visitListenerElement, signalsDisplayElement],
});
